import type { DocDiffPrintButtonHandlers } from './useDocDiffPrintButtonHandlers.types';
import type { useDocDiff } from 'shared/features/documents/hooks';
import type { DocDiffPrintButtonData } from './useDocDiffPrintButtonData.types';

import * as analytics from 'utils/analytics';
import { delay } from 'utils/timeout';
import { PRINT_CONTENT_ARRANGEMENT_DELAY } from '../DocDiffPrintButton.constants';

import { usePrint } from '@compliance.ai/web-components';

export const useDocDiffPrintButtonHandlers = ({
  docsDiff,
  refs
}: {
  docsDiff: ReturnType<typeof useDocDiff>;
  refs: DocDiffPrintButtonData['refs'];
}): DocDiffPrintButtonHandlers => {
  const print = usePrint({
    bodyClass: 'document-workspace__pdf-body',
    documentTitle: `Document changes`,
    contentRef: refs.documentDiff,
    pageStyle: `
      @page {
        margin: 0;
        padding: 0;
        color: black;
      }
    `,
    onBeforePrint: async () => {
      await delay(PRINT_CONTENT_ARRANGEMENT_DELAY);
    }
  });

  const handlePrint: DocDiffPrintButtonHandlers['handlePrint'] = () => {
    analytics.safe_analytics('Doc Details-Print Changes', 'Doc Details', 'Print Changes');
    if (!docsDiff.diff) {
      return;
    }
    print();
  };

  return {
    handlePrint
  };
};
